import { message, Tag, Descriptions } from "antd";
import { LockOutlined } from "@ant-design/icons";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ModalItem, TablaEditor } from "../../../../Components/Items";
import moment from "moment";
import "moment/locale/es";

moment.locale("es");

const COLUMNAS_FIJAS = [
    { nombre: "Antigüedad", tipo: "numero" },
    { nombre: "Días Vacaciones", tipo: "numero" },
    { nombre: "Porc. Prima Vacacional", tipo: "numero" },
    { nombre: "Días Aguinaldo", tipo: "numero" },
    { nombre: "Factor Integración", tipo: "numero" },
    { nombre: "Días Antigüedad", tipo: "numero" },
];

class VerTipoPrestacion extends Component {
    state = {
        loading: false,
        datos: null,
        filas: [],
    };

    componentDidUpdate(prevProps) {
        if (prevProps.visible !== this.props.visible) {
            if (this.props.visible && this.props.tipoPrestacionId) {
                this.setState({ datos: null, filas: [] });
                this.consultarDatos(this.props.tipoPrestacionId);
            }
        }
    }

    consultarDatos(id) {
        this.setState({ loading: true });
        axios
            .post(
                "tiposPrestaciones/datosTipoPrestacion",
                { tipoPrestacionId: id, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success !== 2) {
                    message.error("No se encontraron los datos del tipo de prestación");
                } else {
                    const { filas, ...datos } = res.data.data;
                    const filasConKey = (filas || []).map((f, i) => ({ ...f, key: i }));
                    this.setState({ datos, filas: filasConKey });
                }
            })
            .catch(() => {
                this.setState({ loading: false });
                message.error("Error al comunicarse con el servidor");
            });
    }

    cerrarModal = () => {
        this.props.cerrarVerTipoPrestacion();
        this.setState({ datos: null, filas: [] });
    };

    render() {
        const { datos, filas } = this.state;

        const titulo = datos ? (
            <span>
                {datos.nombre}
                {datos.esSistema && (
                    <Tag color="gold" style={{ marginLeft: 8 }}>
                        <LockOutlined style={{ marginRight: 4 }} />Sistema
                    </Tag>
                )}
            </span>
        ) : "Ver Tipo de Prestación";

        return (
            <ModalItem
                title={titulo}
                visible={this.props.visible}
                spinning={this.state.loading}
                onCancel={this.cerrarModal}
                width={900}
                footer={null}
            >
                {datos && (
                    <>
                        <Descriptions size="small" bordered column={3} style={{ marginBottom: 16 }}>
                            <Descriptions.Item label="Ejercicio">{datos.ejercicio}</Descriptions.Item>
                            <Descriptions.Item label="Nombre Fórmula">
                                <span style={{ fontFamily: "monospace" }}>{datos.nombreFormula || "—"}</span>
                            </Descriptions.Item>
                            <Descriptions.Item label="Vigencia">
                                {datos.fechaInicioVigencia ? moment(datos.fechaInicioVigencia).format("DD/MMM/YYYY") : "?"}
                                {" — "}
                                {datos.fechaFinVigencia ? moment(datos.fechaFinVigencia).format("DD/MMM/YYYY") : "?"}
                            </Descriptions.Item>
                            {datos.descripcion && (
                                <Descriptions.Item label="Descripción" span={3}>{datos.descripcion}</Descriptions.Item>
                            )}
                        </Descriptions>

                        <TablaEditor
                            columnas={COLUMNAS_FIJAS}
                            filas={filas}
                            onChange={() => { }}
                            columnasFijas
                            readOnly
                        />
                    </>
                )}
            </ModalItem>
        );
    }
}

const mapStateToProps = (state) => ({
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(VerTipoPrestacion);